import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens-index.css'
import './styles/app.css'
import './styles/hub.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
